import { configureStore, combineReducers, getDefaultMiddleware } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import textEditorReducer from './textEditorReducer';

const textEditorPersistConfig = {
  key: 'textEditor',
  storage,
  whitelist: ['activeVersionIndex', 'diffMode']
};

const store = configureStore({
  reducer: combineReducers({
    textEditor: persistReducer(textEditorPersistConfig, textEditorReducer)
  }),
  middleware: getDefaultMiddleware({
    thunk: false,
    serializableCheck: false
  })
});

export const persistor = persistStore(store);
export default store;



// WEBPACK FOOTER //
// ./app/javascript/client/store/storeConfig.js